export enum Method {
  APPEND = 'append',
  OVERWRITE = 'overwrite',
}
